// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RequestCard-div {
  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  padding: 20px;
  width: 80%;
  margin: 20px auto;
  font-family: fira-sans, sans-serif;
  border: 1px solid #e0e0e0;
}

.RequestCard-title {
  margin-top: 0;
  color: #0d7c66;
  text-align: center;
  font-weight: bold;
  font-size: 22px;
  text-transform: uppercase;
}

.raised-by-box {
  border-radius: 5px;
  align-items: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.user-info {
  display: flex;
  align-items: left;
}

.user-icon {
  font-size: 40px;
  color: #555;
  margin-right: 10px;
}

.user-details p {
  margin: 0;
}

.user-name {
  font-weight: bold;
}

.status {
  color: green;
  font-weight: bold;
}

.name-status-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.name,
.status {
  display: flex;
  flex-direction: column;
}

.name p,
.status p {
  margin: 0;
}

.user-status {
  color: green;
  font-weight: bold;
}

.box {
  border: 1px solid #e0e0e0;
  padding: 4px 15px;
  border-radius: 5px;
  background-color: #f9f9f9;
  margin-bottom: 7px;
}

.box-title {
  margin-top: 0;
  margin-bottom: 5px;
  font-weight: bold;
  color: #666;
  align-self: flex-start;
}
.reason_of_leave {
  padding: 10px 0px;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  height: 200px;
  overflow-y: scroll;
}

.insideContainer {
  display: flex;
  justify-content: space-between;
}

.leaves-box,
.applied-dates-box,
.approvers-box {
  display: flex;
  flex-direction: column;
}
.applied-dates-box p{
  margin-left: 10px;
}
.applied-dates-box p,
.leaves-box p,
.reasons-box p {
  align-items: left;
  font-size: 13px;
}

.remark-input {
  margin: 5px;
}
.applied_date_table_header {
  font-size: 13px;
}
.box-reason {
  width: 100%;
}

.reasons-box {
  display: flex;
  gap: 10px;
  padding: 5px;
}

.leaves-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.leave-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}

.actions {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.actions button {
  padding: 8px 10px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
  flex: 1 1;
  margin: 0 5px;
}

.actions .approve {
  background-color: #84c7ae;
  color: #fff;
}

.actions .rejectBtn {
  background: linear-gradient(#f53b3b 81%, transparent 19%);
  color: #fff;
}
.approve.loading{
  display: flex;
  align-items: center;
  justify-content: center;
   background: linear-gradient(#f53b3b 81%, transparent 19%);
  .rejectBtn{
    opacity: 0%;
  }
}
.approvers-box {
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
}

.approvers-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 450px;
}

.approvers-table th,
.approvers-table td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;
  white-space: nowrap;
}

.approvers-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.status-box {
  margin: 0;
}

.table-common {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.table-common th,
.table-common td {
  border: 1px solid #ddd;
  padding: 8px;
}

.table-common th {
  background-color: #f4f4f4;
  font-weight: bold;
  text-align: center;
  font-size: 13px;
}

.table-common tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

.table-common tbody tr:hover {
  background-color: #f1f1f1;
}

.applied-dates-table .applied_date_table_header th {
  background-color: #f4f4f4;
}

/* .leaves-box {
  font-size: 13px;
} */

.small-text {
  font-size: 14px;
  color: #555;
}

.box-title {
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 4px;
  margin-left: 10px;
}

/* .reasons-box {
  margin-top: 20px;
} */

.box-reason {
  padding: 10px;
  margin: 5px;
  border: 1px solid #ccc;
  background-color: #f9f9f9;
}

.actions {
  margin-top: 1px;
  display: flex;
  gap: 10px;
}

.approve {
  background-color: #28a745;
  color: #fff;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 4px;
}

.reject {
  background-color: #dc3545;
  color: #fff;
  border: none;
  padding: 10px 15px;
  cursor: pointer;
  border-radius: 4px;
}

.approve:hover,
.reject:hover {
  opacity: 0.9;
}

.approver_status {
  color: #84c7ae;
  font-size: 14px;
  padding: 5px 10px ;
  margin: 0;
}
.approver_status_head {
  color: #000;
  font-size: 13px;
  opacity: 50%;
}
.approver_status_heading{
  color:  #0d7c66; 
}

.reason-col{
 text-align:left;
 padding: 0px 2px;
 color:#444444
}

@media (max-width: 600px) {

  .RequestCard-div {
    width: 95%;
    padding: 12px;
    margin: 10px auto;
  }

  .RequestCard-title {
    font-size: 16px;
  }

  .raised-by-box,
  .name-status-row,
  .insideContainer,
  .leaves-container,
  .leave-row {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .user-icon {
    font-size: 30px;
  }

  .user-details p,
  .small-text,
  .applied-dates-box p,
  .leaves-box p,
  .reasons-box p {
    font-size: 12px;
  }

  .container {
    height: auto;
    max-height: 250px;
  }

  .approvers-box {
    overflow-x: auto;
  }

  .approvers-table {
    min-width: 400px;
  }

  .table-common th,
  .table-common td {
    font-size: 12px;
    padding: 6px;
  }

  .actions {
    flex-direction: column;
    gap: 8px;
  }

  .actions button {
    width: 100%;
    font-size: 13px;
  }

  .box-title {
    font-size: 13px;
  }

  .box {
    padding: 6px 10px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/Request/Leave/Leave.css"],"names":[],"mappings":"AAAA;EACE,4EAA4E;EAC5E,kBAAkB;EAClB,wCAAwC;EACxC,aAAa;EACb,UAAU;EACV,iBAAiB;EACjB,kCAAkC;EAClC,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;;;EAGE,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;;;EAGE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,SAAO;EACP,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yDAAyD;EACzD,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;GACtB,yDAAyD;EAC1D;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;GAEG;;AAEH;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;AACjB;;AAEA;CACC,eAAe;CACf,gBAAgB;CAChB;AACD;;AAEA;;EAEE;IACE,UAAU;IACV,aAAa;IACb,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,sBAAsB;IACtB,uBAAuB;IACvB,QAAQ;EACV;;EAEA;IACE,eAAe;EACjB;;EAEA;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,eAAe;IACf,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".RequestCard-div {\n  background: linear-gradient(to bottom, #ffffff -8%, #e0ece0 59%, #ddebdd 0%);\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n  padding: 20px;\n  width: 80%;\n  margin: 20px auto;\n  font-family: fira-sans, sans-serif;\n  border: 1px solid #e0e0e0;\n}\n\n.RequestCard-title {\n  margin-top: 0;\n  color: #0d7c66;\n  text-align: center;\n  font-weight: bold;\n  font-size: 22px;\n  text-transform: uppercase;\n}\n\n.raised-by-box {\n  border-radius: 5px;\n  align-items: left;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.user-info {\n  display: flex;\n  align-items: left;\n}\n\n.user-icon {\n  font-size: 40px;\n  color: #555;\n  margin-right: 10px;\n}\n\n.user-details p {\n  margin: 0;\n}\n\n.user-name {\n  font-weight: bold;\n}\n\n.status {\n  color: green;\n  font-weight: bold;\n}\n\n.name-status-row {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n\n.name,\n.status {\n  display: flex;\n  flex-direction: column;\n}\n\n.name p,\n.status p {\n  margin: 0;\n}\n\n.user-status {\n  color: green;\n  font-weight: bold;\n}\n\n.box {\n  border: 1px solid #e0e0e0;\n  padding: 4px 15px;\n  border-radius: 5px;\n  background-color: #f9f9f9;\n  margin-bottom: 7px;\n}\n\n.box-title {\n  margin-top: 0;\n  margin-bottom: 5px;\n  font-weight: bold;\n  color: #666;\n  align-self: flex-start;\n}\n.reason_of_leave {\n  padding: 10px 0px;\n}\n.container {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  height: 200px;\n  overflow-y: scroll;\n}\n\n.insideContainer {\n  display: flex;\n  justify-content: space-between;\n}\n\n.leaves-box,\n.applied-dates-box,\n.approvers-box {\n  display: flex;\n  flex-direction: column;\n}\n.applied-dates-box p{\n  margin-left: 10px;\n}\n.applied-dates-box p,\n.leaves-box p,\n.reasons-box p {\n  align-items: left;\n  font-size: 13px;\n}\n\n.remark-input {\n  margin: 5px;\n}\n.applied_date_table_header {\n  font-size: 13px;\n}\n.box-reason {\n  width: 100%;\n}\n\n.reasons-box {\n  display: flex;\n  gap: 10px;\n  padding: 5px;\n}\n\n.leaves-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n}\n\n.leave-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n}\n\n.actions {\n  display: flex;\n  justify-content: space-between;\n  margin-top: 20px;\n}\n\n.actions button {\n  padding: 8px 10px;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  font-size: 14px;\n  flex: 1;\n  margin: 0 5px;\n}\n\n.actions .approve {\n  background-color: #84c7ae;\n  color: #fff;\n}\n\n.actions .rejectBtn {\n  background: linear-gradient(#f53b3b 81%, transparent 19%);\n  color: #fff;\n}\n.approve.loading{\n  display: flex;\n  align-items: center;\n  justify-content: center;\n   background: linear-gradient(#f53b3b 81%, transparent 19%);\n  .rejectBtn{\n    opacity: 0%;\n  }\n}\n.approvers-box {\n  overflow-x: auto;\n  overflow-y: hidden;\n  white-space: nowrap;\n}\n\n.approvers-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 450px;\n}\n\n.approvers-table th,\n.approvers-table td {\n  padding: 10px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n  white-space: nowrap;\n}\n\n.approvers-table th {\n  background-color: #f2f2f2;\n  font-weight: bold;\n}\n\n.status-box {\n  margin: 0;\n}\n\n.table-common {\n  width: 100%;\n  border-collapse: collapse;\n  text-align: left;\n}\n\n.table-common th,\n.table-common td {\n  border: 1px solid #ddd;\n  padding: 8px;\n}\n\n.table-common th {\n  background-color: #f4f4f4;\n  font-weight: bold;\n  text-align: center;\n  font-size: 13px;\n}\n\n.table-common tbody tr:nth-child(even) {\n  background-color: #f9f9f9;\n}\n\n.table-common tbody tr:hover {\n  background-color: #f1f1f1;\n}\n\n.applied-dates-table .applied_date_table_header th {\n  background-color: #f4f4f4;\n}\n\n/* .leaves-box {\n  font-size: 13px;\n} */\n\n.small-text {\n  font-size: 14px;\n  color: #555;\n}\n\n.box-title {\n  font-size: 14px;\n  font-weight: bold;\n  margin-bottom: 4px;\n  margin-left: 10px;\n}\n\n/* .reasons-box {\n  margin-top: 20px;\n} */\n\n.box-reason {\n  padding: 10px;\n  margin: 5px;\n  border: 1px solid #ccc;\n  background-color: #f9f9f9;\n}\n\n.actions {\n  margin-top: 1px;\n  display: flex;\n  gap: 10px;\n}\n\n.approve {\n  background-color: #28a745;\n  color: #fff;\n  border: none;\n  padding: 10px 15px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.reject {\n  background-color: #dc3545;\n  color: #fff;\n  border: none;\n  padding: 10px 15px;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.approve:hover,\n.reject:hover {\n  opacity: 0.9;\n}\n\n.approver_status {\n  color: #84c7ae;\n  font-size: 14px;\n  padding: 5px 10px ;\n  margin: 0;\n}\n.approver_status_head {\n  color: #000;\n  font-size: 13px;\n  opacity: 50%;\n}\n.approver_status_heading{\n  color:  #0d7c66; \n}\n\n.reason-col{\n text-align:left;\n padding: 0px 2px;\n color:#444444\n}\n\n@media (max-width: 600px) {\n\n  .RequestCard-div {\n    width: 95%;\n    padding: 12px;\n    margin: 10px auto;\n  }\n\n  .RequestCard-title {\n    font-size: 16px;\n  }\n\n  .raised-by-box,\n  .name-status-row,\n  .insideContainer,\n  .leaves-container,\n  .leave-row {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 8px;\n  }\n\n  .user-icon {\n    font-size: 30px;\n  }\n\n  .user-details p,\n  .small-text,\n  .applied-dates-box p,\n  .leaves-box p,\n  .reasons-box p {\n    font-size: 12px;\n  }\n\n  .container {\n    height: auto;\n    max-height: 250px;\n  }\n\n  .approvers-box {\n    overflow-x: auto;\n  }\n\n  .approvers-table {\n    min-width: 400px;\n  }\n\n  .table-common th,\n  .table-common td {\n    font-size: 12px;\n    padding: 6px;\n  }\n\n  .actions {\n    flex-direction: column;\n    gap: 8px;\n  }\n\n  .actions button {\n    width: 100%;\n    font-size: 13px;\n  }\n\n  .box-title {\n    font-size: 13px;\n  }\n\n  .box {\n    padding: 6px 10px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
